/**
 * Provider logo mapping — maps provider names to their logo assets.
 * Falls back to null when no logo is available.
 * 99 logos downloaded from provider websites (128px favicons).
 */
import { ImageSourcePropType } from 'react-native'

const PROVIDER_LOGOS: Record<string, ImageSourcePropType> = {
  '3 (Hi3G Denmark)': require('../../assets/provider-logos/3-dk.png'),
  '3 (Tre/Hi3G)': require('../../assets/provider-logos/3-dk.png'),
  'AURA': require('../../assets/provider-logos/aura-dk.png'),
  'AURA Energi': require('../../assets/provider-logos/aura-dk.png'),
  'AURA Fiber': require('../../assets/provider-logos/aura-dk.png'),
  'Airbox': require('../../assets/provider-logos/airbox-dk.png'),
  'Altibox': require('../../assets/provider-logos/altibox-dk.png'),
  'Altibox Mobil': require('../../assets/provider-logos/altibox-dk.png'),
  'Altid Energi': require('../../assets/provider-logos/altidenergi-dk.png'),
  'Andel Energi': require('../../assets/provider-logos/andelenergi-dk.png'),
  'Bahnhof': require('../../assets/provider-logos/bahnhofinternet-dk.png'),
  'Bolig:net': require('../../assets/provider-logos/bolignet-dk.png'),
  'Born Fiber': require('../../assets/provider-logos/bornfiber-dk.png'),
  'Bornholms Energi': require('../../assets/provider-logos/beof-dk.png'),
  'Boxer': require('../../assets/provider-logos/boxer-dk.png'),
  'Budget Energi': require('../../assets/provider-logos/budgetenergi-dk.png'),
  'CBB': require('../../assets/provider-logos/cbb-dk.png'),
  'CBB Internet': require('../../assets/provider-logos/cbb-dk.png'),
  'Call me': require('../../assets/provider-logos/callme-dk.png'),
  'Cheap Energy': require('../../assets/provider-logos/cheapenergy-dk.png'),
  'Clever': require('../../assets/provider-logos/clever-dk.png'),
  'DCC Energi': require('../../assets/provider-logos/www-dccenergi-dk.png'),
  'Dansk Energiforsyning': require('../../assets/provider-logos/danskenergiforsyning-com.png'),
  'Dansk Kabel TV': require('../../assets/provider-logos/dktv-dk.png'),
  'Dansk Net': require('../../assets/provider-logos/dansknet-dk.png'),
  'Dansk Stroem': require('../../assets/provider-logos/danskstrom-dk.png'),
  'E-GO': require('../../assets/provider-logos/e-go-dk.png'),
  'EGO': require('../../assets/provider-logos/e-go-dk.png'),
  'ENLY': require('../../assets/provider-logos/enly-dk.png'),
  'EVDK': require('../../assets/provider-logos/evdk-dk.png'),
  'EWII': require('../../assets/provider-logos/ewii-dk.png'),
  'EWII Energi': require('../../assets/provider-logos/ewii-dk.png'),
  'Energi Fyn Bredbånd': require('../../assets/provider-logos/energifyn-dk.png'),
  'Energi Fyn Handel': require('../../assets/provider-logos/energifyn-dk.png'),
  'Energi Viborg': require('../../assets/provider-logos/energiviborg-dk.png'),
  'Energi+': require('../../assets/provider-logos/energiplus-dk.png'),
  'EnergiX': require('../../assets/provider-logos/energix-dk.png'),
  'Energidrift': require('../../assets/provider-logos/energidrift-dk.png'),
  'Energy Nordic': require('../../assets/provider-logos/energynordic-dk.png'),
  'Enkel Energi': require('../../assets/provider-logos/enkelenergi-dk.png'),
  'Evercall': require('../../assets/provider-logos/evercall-dk.png'),
  'Fair Stroem': require('../../assets/provider-logos/fairstrom-dk.png'),
  'Fairpris': require('../../assets/provider-logos/fairpris-dk.png'),
  'Fastspeed': require('../../assets/provider-logos/fastspeed-dk.png'),
  'Fibia': require('../../assets/provider-logos/fibia-dk.png'),
  'Forskel': require('../../assets/provider-logos/forskel-dk.png'),
  'Forsyningen': require('../../assets/provider-logos/forsyningen-dk.png'),
  'GEV Elhandel': require('../../assets/provider-logos/gev-dk.png'),
  'Gasel': require('../../assets/provider-logos/gasel-dk.png'),
  'Glenten Mobil': require('../../assets/provider-logos/glentenmobil-dk.png'),
  'Green Power Energy': require('../../assets/provider-logos/greenpowerenergy-dk.png'),
  'GreenSpeak': require('../../assets/provider-logos/greenspeak-dk.png'),
  'Greenbow': require('../../assets/provider-logos/greenbow-dk.png'),
  'Greentel': require('../../assets/provider-logos/greentel-dk.png'),
  'Hallo Mobil': require('../../assets/provider-logos/hallo-dk.png'),
  'Hiper': require('../../assets/provider-logos/hiper-dk.png'),
  'Jysk Energi': require('../../assets/provider-logos/jyskenergi-dk.png'),
  'Kaernfull Energi': require('../../assets/provider-logos/karnfull-dk.png'),
  'Kazoom': require('../../assets/provider-logos/kazoom-dk.png'),
  'Keima': require('../../assets/provider-logos/keima-energy.png'),
  'Kronborg El / Forsyning Helsingoer': require('../../assets/provider-logos/fh-dk.png'),
  'Lebara': require('../../assets/provider-logos/lebara-dk.png'),
  'Lokal Energi': require('../../assets/provider-logos/lokal-energi-dk.png'),
  'Looad': require('../../assets/provider-logos/looad-dk.png'),
  'Lycamobile': require('../../assets/provider-logos/lycamobile-dk.png'),
  'Maxtel': require('../../assets/provider-logos/maxtel-dk.png'),
  'Minitel': require('../../assets/provider-logos/minitel-dk.png'),
  'Mit Tele': require('../../assets/provider-logos/mittele-dk.png'),
  'Modstrøm': require('../../assets/provider-logos/modstroem-dk.png'),
  'NRGi Elhandel': require('../../assets/provider-logos/nrgi-dk.png'),
  'Nettalk': require('../../assets/provider-logos/nettalk-dk.png'),
  'Netto Power': require('../../assets/provider-logos/nettopower-dk.png'),
  'Nordisk Energi': require('../../assets/provider-logos/nordiskenergi-dk.png'),
  'Norlys': require('../../assets/provider-logos/norlys-dk.png'),
  'Norlys Energi': require('../../assets/provider-logos/norlys-dk.png'),
  'Norlys Mobil': require('../../assets/provider-logos/norlys-dk.png'),
  'OK': require('../../assets/provider-logos/ok-dk.png'),
  'Oe/stroem': require('../../assets/provider-logos/o-strom-dk.png'),
  'OiSTER': require('../../assets/provider-logos/oister-dk.png'),
  'OiSTER Internet': require('../../assets/provider-logos/oister-dk.png'),
  'Power Fuel': require('../../assets/provider-logos/powerfuel-dk.png'),
  'Relatel': require('../../assets/provider-logos/relatel-dk.png'),
  'SEF Energi': require('../../assets/provider-logos/sefenergi-dk.png'),
  'SK Energi': require('../../assets/provider-logos/skenergi-dk.png'),
  'Samstroem': require('../../assets/provider-logos/samstrom-dk.png'),
  'Stofa': require('../../assets/provider-logos/stofa-dk.png'),
  'Stroemlinet': require('../../assets/provider-logos/stromlinet-dk.png'),
  'Stroemtid': require('../../assets/provider-logos/stromtid-dk.png'),
  'Struer Energi Handel': require('../../assets/provider-logos/struerenergi-dk.png'),
  'Telenor': require('../../assets/provider-logos/telenor-dk.png'),
  'Telia': require('../../assets/provider-logos/telia-dk.png'),
  'Telmore': require('../../assets/provider-logos/telmore-dk.png'),
  'Telmore Internet': require('../../assets/provider-logos/telmore-dk.png'),
  'Tryg Energi Danmark': require('../../assets/provider-logos/trygenergi-dk.png'),
  'Ungstroem': require('../../assets/provider-logos/ungstrom-dk.png'),
  'Unotel': require('../../assets/provider-logos/unotel-dk.png'),
  'Vedvarende': require('../../assets/provider-logos/vedvarende-dk.png'),
  'Velkommen': require('../../assets/provider-logos/velkommen-dk.png'),
  'Verdo GoGreen': require('../../assets/provider-logos/verdo-com.png'),
  'Verdo Go Green': require('../../assets/provider-logos/verdo-com.png'),
  'Vestforsyning El': require('../../assets/provider-logos/vestforsyning-dk.png'),
  'Vesthimmerlands El-Forsyning': require('../../assets/provider-logos/vhel-dk.png'),
  'Vindstoed': require('../../assets/provider-logos/vindstod-dk.png'),
  'Viptel': require('../../assets/provider-logos/viptel-dk.png'),
  'Waoo': require('../../assets/provider-logos/waoo-dk.png'),
  'Waoo Mobil': require('../../assets/provider-logos/mobil-waoo-dk.png'),
  'YouSee': require('../../assets/provider-logos/yousee-dk.png'),
  'b.energy': require('../../assets/provider-logos/b-energy.png'),
  'dukaTALE': require('../../assets/provider-logos/duka-dk.png'),
  'eesy': require('../../assets/provider-logos/eesy-dk.png'),
  'eesy Internet': require('../../assets/provider-logos/eesy-dk.png'),
  "go\u2019energi": require('../../assets/provider-logos/go-energi-dk.png'),
  "go'energi": require('../../assets/provider-logos/go-energi-dk.png'),
  'Go Energi': require('../../assets/provider-logos/go-energi-dk.png'),
  'nef Stroem': require('../../assets/provider-logos/nef-dk.png'),
}

/** Normalize provider name for fuzzy matching */
function normalize(name: string): string {
  return name
    .replace(/\s*(A\/S|ApS|a\.m\.b\.a|I\/S|P\/S)\s*/gi, '')  // Remove company suffixes
    .replace(/\s*-\s*\d+\s*\d*$/, '')  // Remove phone numbers like "- 7011 4500"
    .replace(/[.]+$/, '')  // Remove trailing dots (e.g. "Gasel.")
    .replace(/ø/g, 'oe').replace(/Ø/g, 'Oe')
    .replace(/å/g, 'aa').replace(/Å/g, 'Aa')
    .replace(/æ/g, 'ae').replace(/Æ/g, 'Ae')
    .replace(/ä/g, 'ae').replace(/Ä/g, 'Ae')
    .replace(/ö/g, 'oe').replace(/Ö/g, 'Oe')
    .replace(/ü/g, 'u').replace(/Ü/g, 'U')
    .replace(/\u2019/g, "'")  // Right single quote → apostrophe
    .replace(/\u2013|\u2014/g, '/')  // En/em dash → slash
    .replace(/ø/gi, 'oe')  // Catch-all for ø
    .trim()
    .toLowerCase()
}

// Build normalized lookup cache
const _normalizedCache: Record<string, ImageSourcePropType> = {}
for (const [key, value] of Object.entries(PROVIDER_LOGOS)) {
  _normalizedCache[normalize(key)] = value
}

/** Get provider logo source, or null if not available */
export function getProviderLogo(providerName: string): ImageSourcePropType | null {
  // Exact match first
  if (PROVIDER_LOGOS[providerName]) return PROVIDER_LOGOS[providerName]
  // Fuzzy match via normalization
  return _normalizedCache[normalize(providerName)] ?? null
}
